// extracted by mini-css-extract-plugin
export default {"main":"DSIFeatures_main__Ybf+O","header":"DSIFeatures_header__LHcRv","tabs":"DSIFeatures_tabs__1ZtxF","tab":"DSIFeatures_tab__mN1vM font-sm-regular"};